/**
 * Configuración de la API Backend
 * Centraliza todas las URLs y configuraciones de la nueva API
 */

// URL base de la API backend (desde variable de entorno)
//export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8787';
export const API_BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:8787' : 'https://api.revvly.cl';


// Configuración de timeouts
export const API_TIMEOUT = 30000; // 30 segundos (general)
export const CHAT_API_TIMEOUT = 120000; // 120 segundos (2 minutos) - Para Chat IA con GPT

// Headers por defecto
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  'Accept': 'application/json'
};

// Endpoints de la API organizados por módulo
export const API_ENDPOINTS = {
  // Autenticación
  AUTH: {
    ME: '/api/auth/me',
    REGISTER: '/api/auth/register'
  },

  // Usuarios
  USUARIOS: {
    BASE: '/api/usuarios',
    BY_ID: (id) => `/api/usuarios/${id}`,
    BY_CLERK_ID: (clerkId) => `/api/usuarios/clerk/${clerkId}`,
    SUPER_ADMIN_VERIFY: '/api/usuarios/super-admin/verify'
  },

  // Empresas
  EMPRESAS: {
    BASE: '/api/empresas',
    BY_ID: (id) => `/api/empresas/${id}`,
    TODAS: '/api/empresas/todas',
    BY_CODIGO: '/api/empresas/codigo',
    VERIFICAR_CODIGO: '/api/empresas/verificar-codigo',
    USUARIOS: (id) => `/api/empresas/${id}/usuarios`
  },

  // Estados
  ESTADOS: {
    BASE: '/api/estados',
    BY_ID: (id) => `/api/estados/${id}`,
    BY_ENTIDAD: (entidad) => `/api/estados?entidad=${entidad}`,
    BY_NOMBRE: '/api/estados/search',
    STATS: '/api/estados/stats',
    GROUPED: '/api/estados?grouped=true'
  },

  // Categorías
  CATEGORIAS: {
    BASE: '/api/categorias',
    BY_ID: (id) => `/api/categorias/${id}`,
    BY_TIPO: (tipo) => `/api/categorias?tipo=${tipo}`,
    GROUPED: '/api/categorias?grouped=true'
  },

  // Configuraciones
  CONFIGURACIONES: {
    BASE: '/api/configuraciones',
    BY_CLAVE: (clave) => `/api/configuraciones/${clave}`,
    GLOBAL: '/api/configuraciones/global',
    GLOBAL_BY_CLAVE: (clave) => `/api/configuraciones/global/${clave}`
  },

  // Sucursales
  SUCURSALES: {
    BASE: '/api/sucursales',
    BY_ID: (id) => `/api/sucursales/${id}`
  },

  // Clientes
  CLIENTES: {
    BASE: '/api/clientes',
    BY_ID: (id) => `/api/clientes/${id}`,
    BY_EMAIL: (email) => `/api/clientes/email/${email}`,
    BY_RUT: (rut) => `/api/clientes/rut/${rut}`,
    BY_CLERK_ID: (clerkId) => `/api/clientes/clerk/${clerkId}`,
    BUSCAR: '/api/clientes/buscar'
  },

  // Vehículos
  VEHICULOS: {
    BASE: '/api/vehiculos',
    BY_ID: (id) => `/api/vehiculos/${id}`,
    BY_CLIENTE: (clienteId) => `/api/vehiculos/cliente/${clienteId}`,
    BY_PATENTE: (patente) => `/api/vehiculos/patente/${patente}`
  },

  // Mecánicos
  MECANICOS: {
    BASE: '/api/mecanicos',
    BY_ID: (id) => `/api/mecanicos/${id}`
  },

  // Servicios
  SERVICIOS: {
    BASE: '/api/servicios',
    BY_ID: (id) => `/api/servicios/${id}`,
    BY_CATEGORIA: (categoriaId) => `/api/servicios/categoria/${categoriaId}`
  },

  // Citas
  CITAS: {
    BASE: '/api/citas',
    BY_ID: (id) => `/api/citas/${id}`,
    BY_CLIENTE: (clienteId) => `/api/citas/cliente/${clienteId}`,
    BY_EMPRESA: (empresaId) => `/api/citas/empresa/${empresaId}`,
    SERVICIOS: (citaId) => `/api/citas/${citaId}/servicios`,
    IMAGENES: (citaId) => `/api/citas/${citaId}/imagenes`,
    IMAGEN_BY_ID: (citaId, imagenId) => `/api/citas/${citaId}/imagenes/${imagenId}`,
    BUSCAR: '/api/citas/buscar'
  },

  // Mantenimientos
  MANTENIMIENTOS: {
    BASE: '/api/mantenimientos',
    BY_ID: (id) => `/api/mantenimientos/${id}`,
    BY_VEHICULO: (vehiculoId) => `/api/mantenimientos/vehiculo/${vehiculoId}`,
    BY_CITA: (citaId) => `/api/mantenimientos/por-cita/${citaId}`,
    HISTORIAL: (patente) => `/api/mantenimientos/historial/${patente}`,
    PDF: (id) => `/api/mantenimientos/${id}/pdf`,
    IMAGENES: (mantenimientoId) => `/api/mantenimientos/${mantenimientoId}/imagenes`,
    IMAGEN_BY_ID: (mantenimientoId, imagenId) => `/api/mantenimientos/${mantenimientoId}/imagenes/${imagenId}`
  },

  // Repuestos
  REPUESTOS: {
    BASE: '/api/repuestos',
    BY_ID: (id) => `/api/repuestos/${id}`,
    BUSCAR: '/api/repuestos/buscar'
  },

  // Festivos
  FESTIVOS: {
    BASE: '/api/festivos',
    BY_ID: (id) => `/api/festivos/${id}`,
    BY_YEAR: (year) => `/api/festivos/year/${year}`,
    BY_DATE_RANGE: '/api/festivos/range',
    BY_SUCURSAL: (sucursalId) => `/api/festivos/sucursal/${sucursalId}`
  },

  // Fechas Especiales
  FECHAS_ESPECIALES: {
    BASE: '/api/fechas-especiales',
    BY_ID: (id) => `/api/fechas-especiales/${id}`,
    BY_SUCURSAL: (sucursalId) => `/api/fechas-especiales/sucursal/${sucursalId}`,
    BY_DATE_RANGE: '/api/fechas-especiales/range'
  },

  // Horarios Bloqueados
  HORARIOS_BLOQUEADOS: {
    BASE: '/api/horarios-bloqueados',
    BY_ID: (id) => `/api/horarios-bloqueados/${id}`,
    BY_SUCURSAL: (sucursalId) => `/api/horarios-bloqueados/sucursal/${sucursalId}`,
    BY_DATE: (fecha) => `/api/horarios-bloqueados/fecha/${fecha}`,
    BY_DATE_RANGE: '/api/horarios-bloqueados/range'
  },

  // Estadísticas
  ESTADISTICAS: {
    BASE: '/api/estadisticas'
  },

  // Patentes
  PATENTES: {
    CONSULTAR: '/api/consultar-patente',
    CREAR_CLIENTE_VEHICULO: '/api/crear-cliente-vehiculo-patente',
    ESTADISTICAS: '/api/stats-patentes',
    LIMPIAR_CACHE: '/api/limpiar-cache-patentes'
  },

  // Catálogo de Vehículos (Boostr.cl)
  VEHICULO_CATALOGO: {
    MARCAS: '/api/vehiculos/marcas',
    MODELOS: '/api/vehiculos/modelos',
    VERSIONES: '/api/vehiculos/versiones',
    BUSCAR: '/api/vehiculos/buscar',
    COMPLETO: '/api/vehiculos/completo'
  },

  // Catálogo de Vehículos (Base de datos local)
  CATALOGO_VEHICULOS: {
    MARCAS: '/api/catalogo-vehiculos/marcas',
    MODELOS: (marcaId) => `/api/catalogo-vehiculos/marcas/${marcaId}/modelos`,
    SEARCH: '/api/catalogo-vehiculos/search',
    STATS: '/api/catalogo-vehiculos/stats'
  },

  // Chat IA
  CHAT: {
    MESSAGE: '/api/chat/message',
    HISTORY: '/api/chat/history',
    FEEDBACK: '/api/chat/feedback'
  },

  // Health
  HEALTH: '/api/health',
  DEBUG: '/api/debug'
};

// Códigos de error HTTP comunes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503
};

// Configuración de retry
export const RETRY_CONFIG = {
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000, // 1 segundo
  RETRY_STATUS_CODES: [408, 429, 500, 502, 503, 504]
};

// Configuración de logging
export const LOG_CONFIG = {
  ENABLED: process.env.NODE_ENV === 'development',
  LOG_REQUESTS: true,
  LOG_RESPONSES: true,
  LOG_ERRORS: true
};

// Configuración legacy para compatibilidad
export const apiConfig = {
  baseUrl: API_BASE_URL,
  timeout: API_TIMEOUT,
  headers: DEFAULT_HEADERS
};